/*!
 * @copyright
 * Copyright(c) 2018 SICK AG
 */
import { run  } from './Text2DDemo';

run(document.getElementById('viewer'));
